import { TStoreState } from 'redux/types';
import { createSelector } from '@reduxjs/toolkit';
import { TEmExportResponsePayload, TEmExportsStore } from './types';

export const getEmExportsState = (state: TStoreState): TEmExportsStore => state.emExports;

export const getEmExports = getEmExportsState;

// ==========================================:

export const getExportOrders = createSelector(
	[getEmExports],
	(emExports: TEmExportsStore): TEmExportResponsePayload => emExports.exportOrders,
);

// ==========================================:

export const getExportOrdersLoader = createSelector(
	[getEmExports],
	(emExports: TEmExportsStore): boolean => emExports.exportOrdersLoader,
);

// ==========================================:

export const getExportReturns = createSelector(
	[getEmExports],
	(emExports: TEmExportsStore): TEmExportResponsePayload => emExports.exportReturns,
);

// ==========================================:

export const getExportReturnsLoader = createSelector(
	[getEmExports],
	(emExports: TEmExportsStore): boolean => emExports.exportReturnsLoader,
);

// ==========================================:

export const getDownloadEmExportFileLoader = createSelector(
	[getEmExports],
	(emExports: TEmExportsStore): boolean => emExports.downloadFileLoader,
);

// ==========================================:

export const getDownloadEmExportFileError = createSelector(
	[getEmExports],
	(emExports: TEmExportsStore): string | null => emExports.downloadFileError,
);
